import { MetricsOverview } from "../molecules/MetricsOverview";
import { Overview } from "../molecules/Overview";

export const Sent = () => (
  <div className="w-full min-h-screen p-4 bg-gray-100">
    <div className="flex flex-col gap-4">
      <Overview />
      <MetricsOverview />
    </div>
  </div>
);
